import { format, parseISO, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Helper function to safely parse dates
const safeParseDate = (dateString) => {
  if (!dateString) return null;

  // Handle different date formats
  let date;
  if (dateString.includes('T')) {
    date = parseISO(dateString);
  } else {
    // Try to parse the string as a date
    date = new Date(dateString);
  }

  return isValid(date) ? date : null;
};

export default function useFormatters() {
  /**
   * Format currency values to Brazilian Real format
   * @param {number} valor - Value to format
   * @returns {string} - Formatted currency string
   */
  const formatMoeda = (valor) => {
    if (valor === null || valor === undefined) return 'R$ 0,00';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  };

  /**
   * Format dates with a consistent pattern
   * @param {string|Date} dateString - Date to format
   * @returns {string} - Formatted date string
   */
  const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = safeParseDate(dateString);
    if (!date) return dateString; // Return original if parsing failed

    try {
      return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR });
    } catch (e) {
      console.error('Error formatting date:', e);
      return dateString;
    }
  };

  /**
   * Format CPF with mask XXX.XXX.XXX-XX
   * @param {string} cpf - CPF to format
   * @returns {string} - Formatted CPF string
   */
  const formatCpf = (cpf) => {
    if (!cpf) return '';

    // Remove all non-numeric characters
    const cleaned = cpf.replace(/\D/g, '');

    // Apply mask
    if (cleaned.length === 11) {
      return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    return cpf; // Return original if not 11 digits
  };

  return {
    formatMoeda,
    formatDate,
    formatCpf,
    safeParseDate
  };
}
